<div class="EnvironmentIndicator">
    @if (state.environmentInfo()) {
        <p class="EnvironmentName" matTooltip="{{ state.environmentInfo()?.environment }} - {{ state.environmentInfo()?.subEnvironment }}">
            <color-status-indicator [statusColor]="environmentColor()" [borderRadius]="4" /> {{ state.environmentInfo()?.subEnvironment }}
        </p>
        <p class="EnvironmentRegion text-subtle">[{{ state.environmentInfo()?.region | uppercase }}]</p>
    }
</div>
